// Copyright Carrefour(2022)
//

import find from 'lodash-es/find'

const dashboards = [
  // G40 Dashboards
  {
    name: 'International Overview',
    model: 'pos_dashboard_g40',
    icon: 'icon-globe',
    group: 'Overall Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'international-overview-g40',
  },
  {
    name: 'Categories Performance',
    model: 'pos_dashboard_g40',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'categories-performance-g40',
  },
  {
    name: 'Category Performance Details',
    model: 'pos_dashboard_g40',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Class Desc - Key', 'Transaction Date Range'],
    slug: 'category-performance-details-g40',
  },
  {
    name: 'Brand Performance',
    model: 'pos_dashboard_g40',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Brand Desc', 'Transaction Date Range'],
    slug: 'brand-performance-g40',
  },
  {
    name: 'Competition Brand Performance',
    model: 'pos_dashboard_g40',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Brand Desc', 'Class Desc - Key', 'Transaction Date Range'],
    slug: 'competition-brand-performance-g40',
    permission: 'Competition',
    filter: 'Supplier'
  },
  {
    name: 'Channel Performance',
    model: 'pos_dashboard_g40',
    icon: 'icon-channel',
    group: 'Distribution Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'channel-performance-g40',
  },
  {
    name: 'Channel Performance Details',
    model: 'pos_dashboard_g40',
    icon: 'icon-channel',
    group: 'Distribution Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'channel-performance-details-g40',
  },

  // G9 STD Dashboards
  {
    name: 'International Overview',
    model: 'pos_dashboard_weekly_g9',
    icon: 'icon-globe',
    group: 'Overall Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'international-overview-g9-weekly',
  },
  {
    name: 'Categories Performance',
    model: 'pos_dashboard_weekly_g9',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'categories-performance-g9-weekly',
  },
  {
    name: 'Category Performance Details',
    model: 'pos_dashboard_weekly_g9',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Class Desc - Key', 'Transaction Date Range'],
    slug: 'category-performance-details-g9-weekly',
  },
  {
    name: 'Brand Performance',
    model: 'pos_dashboard_weekly_g9',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Brand Desc', 'Transaction Date Range'],
    slug: 'brand-performance-g9-weekly',
  },
  {
    name: 'Competition Brand Performance',
    model: 'pos_dashboard_weekly_g9',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Brand Desc', 'Class Desc - Key', 'Transaction Date Range'],
    slug: 'competition-brand-performance-g9-weekly',
    permission: 'Competition',
    filter: 'Supplier'
  },
  {
    name: 'Channel Performance',
    model: 'pos_dashboard_weekly_g9',
    icon: 'icon-channel',
    group: 'Distribution Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'channel-performance-g9-weekly',
  },
  {
    name: 'Channel Performance Details',
    model: 'pos_dashboard_weekly_g9',
    icon: 'icon-channel',
    group: 'Distribution Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'channel-performance-details-g9-weekly',
  },

  // G9 SBS Dashboards
  {
    name: 'International Overview',
    model: 'pos_dashboard_g9',
    icon: 'icon-globe',
    group: 'Overall Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'international-overview-g9-sbs',
  },
  {
    name: 'Categories Performance',
    model: 'pos_dashboard_g9',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'categories-performance-g9-sbs',
  },
  {
    name: 'Category Performance Details',
    model: 'pos_dashboard_g9',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Class Desc - Key', 'Transaction Date Range'],
    slug: 'category-performance-details-g9-sbs',
  },
  {
    name: 'Brand Performance',
    model: 'pos_dashboard_g9',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Brand Desc', 'Transaction Date Range'],
    slug: 'brand-performance-g9-sbs',
  },
  {
    name: 'Competition Brand Performance',
    model: 'pos_dashboard_g9',
    icon: 'icon-dashboard-default',
    group: 'Products Insights',
    filters: ['Country Name', 'Brand Desc', 'Class Desc - Key', 'Transaction Date Range'],
    slug: 'competition-brand-performance-g9-sbs',
    permission: 'Competition',
    filter: 'Supplier'
  },
  {
    name: 'Channel Performance',
    model: 'pos_dashboard_g9',
    icon: 'icon-channel',
    group: 'Distribution Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'channel-performance-g9-sbs',
  },
  {
    name: 'Channel Performance Details',
    model: 'pos_dashboard_g9',
    icon: 'icon-channel',
    group: 'Distribution Insights',
    filters: ['Country Name', 'Transaction Date Range'],
    slug: 'channel-performance-details-g9-sbs',
  },
  {
    name: 'Store Performance',
    model: 'pos_dashboard_g9',
    icon: 'icon-dashboard-default',
    group: 'Distribution Insights',
    filters: ['Region Desc', 'Country Name', 'Transaction Date Range'],
    slug: 'store-performance-g9-sbs',
  },
]

const findDashoardBySelector = (selector) => {
  return find(dashboards, selector)
}

const findDashoardBySlug = (slug) => {
  return find(dashboards, { slug: slug })
}

const findNameBySlug = (slug) => {
  const dashboard = findDashoardBySlug(slug)
  return dashboard ? dashboard.name : null
}

const findIconBySlug = (slug) => {
  const dashboard = findDashoardBySlug(slug)
  return dashboard ? dashboard.icon : 'icon-dashboard-default'
}

const findGroupBySlug = (slug) => {
  const dashboard = findDashoardBySlug(slug)
  return dashboard ? dashboard.group : 'Overall Insights'
}

const findFiltersBySlug = (slug) => {
  const dashboard = findDashoardBySlug(slug)
  return dashboard ?
    dashboard.filters :
    ['Transaction Date Comparison', 'Transaction Date Range']
}

const useDashboards = () => {
  return {
    findDashoardBySelector,
    findDashoardBySlug,
    findNameBySlug,
    findIconBySlug,
    findGroupBySlug,
    findFiltersBySlug
  }
}

export default useDashboards
